<template>
  <footer class="footer pb-4">
    <b-container>
      <div class="d-flex flex-column flex-sm-row justify-content-md-start justify-content-center flex-wrap w-100">
        <span class="copy-right mb-2 mr-0 mr-sm-4 text-center text-sm-left" v-html="$t('copy_right', { years: '2020'})"></span>
        <ul class="d-flex justify-content-sm-start justify-content-center mb-2">
          <li class="list-item">
            <a class="footer-link" href="https://dashboard.ccr3.com/terms-and-conditions" target="_blank">
            {{ $t('terms_conditions') }}
          </a>
          </li>
          <li class="list-item mx-2">|</li>
          <li class="list-item">
            <a class="footer-link" href="https://dashboard.ccr3.com/privacy-policy" target="_blank">
              {{ $t('privacy_policy') }}
            </a>
          </li>
        </ul>
      </div>
    </b-container>
  </footer>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'

@Component({ name: 'AppFooter' })
export default class AppFooter extends Vue {}
</script>
